import React from 'react'

import { useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import IconButton from '@mui/material/IconButton'
import MenuItem from "@mui/material/MenuItem"
import Checkbox from "@mui/material/Checkbox"
import ListItemText from "@mui/material/ListItemText"
import Badge from "@mui/material/Badge"

import HomeIcon from '@mui/icons-material/Home'
import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'

import * as Utils from './Utils'
import * as AppConst from './AppConst'
import { getDefaultValues } from './ParamUtils'
import MenuButton from './MenuButton'
import { useStore } from './useStore'

function isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches
}

export default function ToolBar({params, setParams}) {
    const navigate = useNavigate()
    const buttonStyle = {
        // padding: '6px',
    }
    const visibility = useStore(state => state.visibility)
    const toggleVisibility = useStore(state => state.toggleVisibility)
    const [showMenuHint, setShowMenuHint] = React.useState(!localStorage.getItem('cinefilter_visibility'))
    const menuApi = {
        close: event => {},
    }
    const visibilityItems = [
        { key: 'directors', label: 'Director' },
        { key: 'actors', label: 'Actors' },
        { key: 'writers', label: 'Writer' },
        { key: 'cinematographers', label: 'Cinematographer' },
        { key: 'prodDesigners', label: 'Prod. Designer' },
        { key: 'composers', label: 'Composer' },
        { key: 'genres', label: 'Genre' },
        { key: 'studios', label: 'Studio' },
        { key: 'countries', label: 'Country' },
        { key: 'language', label: 'Language' },
    ]
    const visibilityToParams = {
        directors: { director: AppConst.director },
        actors: { actor: AppConst.actor },
        writers: { writer: AppConst.writer },
        cinematographers: { cinematographer: AppConst.cinematographer },
        prodDesigners: { prodDesigner: AppConst.prodDesigner },
        composers: { composer: AppConst.composer },
        genres: { reqGenres: AppConst.reqGenres, skipGenres: AppConst.skipGenres },
        studios: { studio: AppConst.studio },
        countries: { country: AppConst.country },
        language: { language: AppConst.language },
    }
    const handleToggle = (key) => {
        if (visibility[key]) {
            setParams(visibilityToParams[key])
        }
        toggleVisibility(key)
    }
    const items = visibilityItems.map(item => (
        <MenuItem
            key={item.key}
            onClick={() => handleToggle(item.key)}
        >
            <Checkbox
                checked={visibility[item.key]}
                size="small"
                sx={{ padding: '2px', marginRight: '8px' }}
            />
            <ListItemText>{item.label}</ListItemText>
        </MenuItem>
    ))
    return (
        <ToolPanel>
            {isStandalone() &&
                <>
                    <IconButton
                        aria-label="back"
                        sx={buttonStyle}
                        onClick={() => navigate(-1)}
                    >
                        <ArrowBack />
                    </IconButton>
                    <IconButton
                        aria-label="forward"
                        sx={{...buttonStyle, marginRight: '10px'}}
                        onClick={() => navigate(1)}
                    >
                        <ArrowForward />
                    </IconButton>
                </>
            }
            <IconButton
                color="primary"
                aria-label="home"
                sx={buttonStyle}
                disabled={Utils.deepEqual(params, getDefaultValues())}
                onClick={() => {
                    // const defaultValues = getDefaultValues()
                    // if (!Utils.deepEqual(params, defaultValues)) {
                    //     setParams(defaultValues)
                    // }
                    setParams(getDefaultValues())
                }}
            >
                <HomeIcon
                    fontSize="large"
                />
            </IconButton>
            <ToolSpringer />
            <MenuButton
                icon={
                    <Badge color="primary" variant="dot" invisible={!showMenuHint}>
                        <MenuRoundedIcon
                            fontSize="large"
                        />
                    </Badge>
                }
                menuRenderer={items}
                menuApi={menuApi}
                onOpen={() => {
                    if (showMenuHint) {
                        setShowMenuHint(false)
                        localStorage.setItem('cinefilter_visibility', JSON.stringify(visibility))
                    }
                }}
            />
        </ToolPanel>
    )
}

const ToolPanel = styled.div`
  display: flex;
  /* gap: 2px; */
`

const ToolSpringer = styled.div`
  flex-grow: 1;
`

